import { render, staticRenderFns } from "./emergo-dialog.vue?vue&type=template&id=5bf30108"
import script from "./emergo-dialog.ts?vue&type=script&lang=js&external"
export * from "./emergo-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports